export interface WifiConnection {
  ssid: string;
  strength: number;
}

export enum DeviceStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
  PAUSED = 'paused',
}
